import { RemoveOutlined } from "@mui/icons-material"
import { Box, Checkbox, Grid, Stack, useTheme } from "@mui/material"
import AppTextField from "components/StyledComponents/AppTextField"
import StyledLabel from "components/StyledComponents/StyledLabel"
import React from "react"

const WeeklySchedule = ({ label = "", formik, title = "", type }) => {
  const theme = useTheme()
  const { setFieldValue, values, errors, touched } = formik || {}

  const hasSetNested = type ? `${type}.${label}` : label

  const ribbonTimings = hasSetNested.split(".").reduce((acc, key) => acc?.[key], values)

  if (!Array.isArray(ribbonTimings)) return null

  return (
    <Grid container>
      <Grid item xs={12} mb={1} mt={1}>
        <StyledLabel>{title}</StyledLabel>
      </Grid>

      <Grid item xs={12} container spacing={2}>
        {ribbonTimings.map((dayItem, index) => {
          const day = dayItem.days
          const nestedPath = `${hasSetNested}[${index}]`

          return (
            <Grid item xs={12} key={index}>
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={2} sm={0.7} mt={3}>
                  <Checkbox
                    style={{ color: theme.palette.secondary.default }}
                    checked={dayItem.checked || false}
                    onChange={(e) => {
                      const isChecked = e.target.checked
                      setFieldValue(`${nestedPath}.checked`, isChecked)
                      if (!isChecked) {
                        setFieldValue(`${nestedPath}.opening_time`, "")
                        setFieldValue(`${nestedPath}.closing_time`, "")
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={5.3}>
                  <AppTextField
                    label="Day"
                    value={day}
                    fullWidth
                    isUpperCase={true}
                    isDisabled={true}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <AppTextField
                      type="time"
                      fullWidth
                      label="Opening Time"
                      isUpperCase={true}
                      isDisabled={!dayItem.checked}
                      value={dayItem.opening_time}
                      onChange={(e) =>
                        setFieldValue(`${nestedPath}.opening_time`, e ? e.target.value : "")
                      }
                      error={
                        touched?.[type]?.[label]?.[index]?.opening_time &&
                        Boolean(errors?.[type]?.[label]?.[index]?.opening_time)
                      }
                      touched={touched?.[type]?.[label]?.[index]?.opening_time}
                      helperText={
                        touched?.[type]?.[label]?.[index]?.opening_time &&
                        errors?.[type]?.[label]?.[index]?.opening_time
                      }
                    />

                    <Box mt={"24px !important"}>
                      <RemoveOutlined />
                    </Box>

                    <AppTextField
                      type="time"
                      fullWidth
                      label="Closing Time"
                      isUpperCase={true}
                      isDisabled={!dayItem.checked}
                      value={dayItem.closing_time}
                      onChange={(e) =>
                        setFieldValue(`${nestedPath}.closing_time`, e ? e.target.value : "")
                      }
                      error={
                        touched?.[type]?.[label]?.[index]?.closing_time &&
                        Boolean(errors?.[type]?.[label]?.[index]?.closing_time)
                      }
                      touched={touched?.[type]?.[label]?.[index]?.closing_time}
                      helperText={
                        touched?.[type]?.[label]?.[index]?.closing_time &&
                        errors?.[type]?.[label]?.[index]?.closing_time
                      }
                    />
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          )
        })}
      </Grid>
    </Grid>
  )
}

export default WeeklySchedule
